






































































































































import { localISO } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import PpiRekapService, { PpiRekapData } from "@/services/PpiRekapService";
import PpiRekapTrendChart from "@/components/ppi/rekap/PpiRekapTrendChart.vue";
import PpiRekapUnitBarChart from "@/components/ppi/rekap/PpiRekapUnitBarChart.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";

@Component({
  components: { PpiRekapTrendChart, PpiRekapUnitBarChart, UnitRuangPicker }
})
export default class PpiRekapPage extends Vue {
  loading = false;
  data: PpiRekapData | null = null;

  filter: {
    module: string;
    from: string;
    to: string;
    unit_id: string | null;
  } = {
    module: "hh_surveilans",
    from: "",
    to: "",
    unit_id: null
  };

  moduleOptions = [
    { text: "Surveilans Hand Hygiene", value: "hh_surveilans" },
    { text: "Surveilans APD", value: "apd_surveilans" },
    { text: "Audit Kebersihan Tangan (HH)", value: "hh_audit" },
    { text: "Audit Kepatuhan APD", value: "apd_audit" },
    { text: "Audit Penyuntikan Aman", value: "injection_audit" },
    { text: "Audit Kebersihan Lingkungan", value: "audit_kesling" },
    { text: "Audit Etika Batuk", value: "audit_etika_batuk" }
  ];

  unitHeaders = [
    { text: "Ruangan / Unit", value: "unit_nama" },
    { text: "Jumlah Sesi", value: "n_sesi", align: "center" },
    { text: "Denominator", value: "den", align: "center" },
    { text: "Kepatuhan", value: "rate", align: "center" }
  ];

  get unitLabels(): string[] {
    return (this.data?.units || []).map(u => u.unit_nama);
  }

  get unitRates(): Array<number | null> {
    return (this.data?.units || []).map(u => u.rate);
  }

  /** Lebar minimum grafik mengikuti jumlah ruangan agar tiap nama bangsal punya ruang. */
  get unitChartMinWidth(): number {
    return this.unitLabels.length * 90;
  }

  mounted() {
    // Default 6 bulan terakhir
    const now = new Date();
    const past = new Date(now.getFullYear(), now.getMonth() - 5, 1);
    this.filter.to = localISO(now).slice(0, 7);
    this.filter.from = localISO(past).slice(0, 7);
    this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: Record<string, string> = { module: this.filter.module };
      if (this.filter.from) params.from = this.filter.from + "-01";
      if (this.filter.to) params.to = this.filter.to + "-01";
      if (this.filter.unit_id) params.unit_id = this.filter.unit_id;

      const resp = await PpiRekapService.getRekap(params as any);
      this.data = resp.data?.data || null;
    } catch (e) {
      this.data = null;
    } finally {
      this.loading = false;
    }
  }

  pctColor(pct: number): string {
    if (pct >= 80) return "green";
    if (pct >= 50) return "orange";
    return "red";
  }
}
